<template>
  <div class="all">

    <div style="cursor: pointer">
      <div class="ALLtitle">
        <div id="classifyScroll" :class="showLeftIcon ? 'active' : ''">
          <div class="classifys">
            <div class="rightIcon">
              <i name="arrow" class="el-icon-arrow-right " v-show="showRightIcon" @click="rightClick" />
            </div>
            <div class="leftIcon">
              <i class="el-icon-arrow-left " v-show="showLeftIcon" @click="leftClick" />
            </div>
            <div class="classifys-item" v-for="(item, index) in menuCheckList" :key="index" :ref="`item${index}`"
              @click="menuNameCheck(item,index)">
              <div class="ctItem" :class="menuCheckCurrentItem == index ? 'currentCT' : ''">
                {{ item.description }}
              </div>
            </div>

          </div>
        </div>


      </div>

    </div>
    <div class="leftMenu">


      <div class="menu">


        <!-- <div v-if="menuCheckDialog" class="menuItem">
          <div v-for="(v, i) in menuCheckList" :key="i" class="menuItemName"
            :class="menuCheckCurrentItem == i ? 'menuItemNameCurrent' : ''" @click="menuNameCheck(v,i)">
            <div>
              {{ v.description }}
            </div>
          </div>
        </div> -->
        <div v-if="!menuCheckDialog">

          <div class="menuDish">
            <div @click="tjClick(v,i)" :class="menuDishStatus == i ? 'menuDishItemCurrent' : ''   " class="menuDishItem"
              v-for="(v,i) in cplx" :key="v+i">
              <img :src="v.pic" onerror="showDefaultImg(this)" width="20px" height="20px"
                style="margin-right: 22px;margin-left:42px" alt="" />
              {{v.name}}
            </div>
          </div>
          <div class="menuClass">
            <div class="menuItem" v-for="(v, i) in menuLeft" :key="v+i" :class="currentac == i ? 'menuItemActive' : ''"
              @click="currentacClick(v,i)">
              {{ v.description }}
              <div class="menuItemNum" v-if="v.menuNum"> {{v.menuNum}} </div>
            </div>
          </div>
        </div>

      </div>

      <div class="dishes">
        <div class="leftdishes">
          <div class="CTClassification">
            <div class="ctItem" v-for="(v, i) in cantList" :key="v+i" :class="current == i ? 'currentCT' : ''"
              @click="currentCheck(i)">
              {{ v.name }}
            </div>
            <!-- <div class="checkStyle"> -->
            <img @click="styleCheck(i)" v-for="(v, i) in styleList" :key="i"
              :src="styleCurrentList == i ? v.CurrentImg:v.imgUrl" width="28px" height="28px" alt="" />
            <!-- </div> -->
          </div>

          <div class="tableClassification" v-if="styleCurrent == 0">
            <div class="tableItem" v-for="(v, i) in tableList" :key="i" @click="clickMenu(v,i)">
              <div class="tableName" :title="v.food_name">{{ v.food_name }}</div>
              <div class="tableNum">
                <span style="font-size: 16px">

                  {{ v.surplus ? '估清'+v.surplus : '' }}

                </span>
                <span style="color: #fe8d30; font-size: 20px">
                  ￥{{ v.is_price_show1 ?  v.unit_price1 : v.unit_price2 }}

                </span>
              </div>
              <div class="topNumber" v-if="v.number">{{v.number}}</div>
              <div class="topImg">
                <img src="../../../assets/imgs/hot.png" v-if="v.is_hot_food" width="20" height="20" alt="">
                <img src="../../../assets/imgs/hyc.png" v-if="v.is_welcome_food" width="20" height="20" alt="">
                <img src="../../../assets/imgs/tjc.png" v-if="v.is_recommend_food" width="20" height="20" alt="">
              </div>
              <div class="topCode" v-if="v.code">
                {{v.code}}
              </div>
            </div>
          </div>

          <div id="tableClassificationTwo" class="tableClassificationTwo" v-else-if="styleCurrent == 1">
            <div class="tableBody">

              <div class="tableItem" v-for="(v, i) in tableList" :key="v.id" @click="clickMenu(v,i)"
                @dblclick="dbclickMenu(v,i)" :class="labelIndex == i ? 'labelIndex' : '' ">


                <div class="tableNum">

                  <div> {{v.code}} </div>
                  <div> {{v.quick_code}} </div>
                  <div> {{v.food_name}} </div>

                  <div class="unitPrice" style="">
                    ￥{{ v.is_price_show1 ? v.unit_price1.toFixed(2) : v.unit_price2.toFixed(2) }}/{{v.unitName}}
                  </div>


                </div>

              </div>
            </div>

          </div>
          <!-- <div class="tableClassificationThree" v-else-if="styleCurrent == 1">
          <div class="tableItem" v-for="(v, i) in tableList" :key="i" @click="clickMenu(v,i)">
            <div class="tableName">
             
              <el-image :src="imgBaseurl+ v.standardPic" lazy fit="cover" style="height:100%;width:140px">
                <div slot="error" class="image-slot">
                  <img src="../../../assets/imgs/none.png" width="140px" height="100%" alt="" />
                </div>
              </el-image>
            </div>
            <div class="rightName">
              <div class="name" :title="v.food_name" style="color: #666666; font-size: 28px; margin-bottom: 34px">
                {{ v.food_name }}
              </div>
              <div class="tableNum">
                <span style="color: #fe8d30; font-size: 20px">￥{{ v.is_price_show1 ? v.unit_price1 : v.unit_price2 }}
                </span>
                <span style="font-size: 16px">                {{ v.surplus ? '估清'+v.surplus : '' }}
 </span>
              </div>
            </div>
            <div class="topNumber" v-if="v.number">{{v.number}}</div>
            <div class="topImg">
              <img src="../../../assets/imgs/hot.png" v-if="v.is_hot_food" width="20" height="20" alt="">
              <img src="../../../assets/imgs/hyc.png" v-if="v.is_welcome_food" width="20" height="20" alt="">
              <img src="../../../assets/imgs/tjc.png" v-if="v.is_recommend_food" width="20" height="20" alt="">
            </div>
              <div class="topCode" v-if="v.code">
              {{v.code}}
            </div>
          </div>
        </div> -->

          <div class="tableClassificationFour" v-else-if="styleCurrent == 2">
            <div class="tableItem" v-for="(v, i) in tableList" :key="i" @click="clickMenu(v,i)">
              <div class="tableName">
                <!-- <img :src="imgBaseurl+v.standardPics" width="100%" height="100%" alt="" /> -->
                <el-image :src="imgBaseurl+ v.ninePics" lazy fit="cover" style="height:100%;width:100%">
                  <div slot="error" class="image-slot">
                    <img src="../../../assets/imgs/none.png" width="100%" height="100%" alt="" />
                  </div>
                </el-image>
              </div>
              <div class="rightName">
                <div class="name" style="color: #fff; font-size: 28px; margin-bottom: 10px">
                  {{ v.food_name }}
                </div>
                <div class="tableNum">
                  <span style="color: #fe8d30; font-size: 20px">￥{{ v.unit_price2 }}
                  </span>
                  <span style="font-size: 16px"> {{ v.surplus ? '估清'+v.surplus : '' }}
                  </span>
                </div>
              </div>
              <div class="topNumber" v-if="v.number">{{v.number}}</div>
              <div class="topImg">
                <img src="../../../assets/imgs/hot.png" v-if="v.is_hot_food" width="20" height="20" alt="">
                <img src="../../../assets/imgs/hyc.png" v-if="v.is_welcome_food" width="20" height="20" alt="">
                <img src="../../../assets/imgs/tjc.png" v-if="v.is_recommend_food" width="20" height="20" alt="">
              </div>
              <div class="topCode" v-if="v.code">
                {{v.code}}
              </div>
            </div>
          </div>
          <div class="tableBottom">

            <el-input placeholder="输入菜品编码、名字、助记码" v-model="inputSearch" clearable ref="selectobjinputSearch"
              style="width: 200px; height: 50px; line-height: 50px" @input="changeSearch"
              @keyup.native.enter="focusNext('selectobjNumber')">
            </el-input>
            <el-input v-model="selectobj.food_name" :disabled='!selectobj.is_can_update_name'
              style="width: 200px; height: 50px; line-height: 50px">
            </el-input>

            <el-input v-model="selectobj.unit_price1" v-if="selectobj.is_price_show1"
              :disabled='!selectobj.is_can_update_price' style="width: 100px; height: 50px; line-height: 50px"
              onfocus="this.select()">
            </el-input>
            <el-input v-model="selectobj.unit_price2" v-if="!selectobj.is_price_show1"
              :disabled='!selectobj.is_can_update_price' style="width: 100px; height: 50px; line-height: 50px"
              onfocus="this.select()">
            </el-input>
            <el-input v-model="selectObjNumber" ref="selectobjNumber"
              style="width: 80px; height: 50px; line-height: 50px" onfocus="this.select()"
              oninput="value=value.replace(/[^\d.]/g,'')" @keyup.native.enter="focusSubmit('selectobjinputSearch')">
            </el-input>


          </div>
        </div>
      </div>


    </div>
  </div>

</template>

<script>
  // import bus from '../../../utils/bus'
  var time = null;
  export default {
    data() {
      return {
        cplx: [{
            name: '推荐菜',
            pic: require('../../../assets/imgs/tjc.png')
          },
          {
            name: '欢迎菜',
            pic: require('../../../assets/imgs/hyc.png')
          },
          {
            name: '热卖菜',
            pic: require('../../../assets/imgs/hot.png')
          },
        ],
        menuDishStatus: -1,
        imgBaseurl: 'http://pmsoss.rooibook.com/',
        menuCheckCurrentItem: 0,
        menuCheckList: [],
        menuCheckDialog: false,
        foodBookName: '',
        styleCurrent: 1,
        styleList: [{
            imgUrl: require("../../../assets/imgs/dish1.png"),
            CurrentImg: require("../../../assets/imgs/dish1c.png")
          },
          // { imgUrl: require("../../../assets/imgs/dish2.png"), CurrentImg: require("../../../assets/imgs/dish2c.png") },
          {
            imgUrl: require("../../../assets/imgs/dish3.png"),
            CurrentImg: require("../../../assets/imgs/dish3c.png")
          },
          {
            imgUrl: require("../../../assets/imgs/dish4.png"),
            CurrentImg: require("../../../assets/imgs/dish4c.png")
          },
        ],
        styleCurrentList: 1,
        inputSearch: "",
        menuLeft: ["沙拉", "前菜", "主菜", "brunch", "酒水", "饮料", "饮料"],
        current: 0,
        isRecommendFood: false,
        isWelcomeFood: false,
        isHotFood: false,
        // 左侧选中按钮下标
        currentac: -1,
        menuNum: 0,
        cantList: [{
          name: "零点"
        }, {
          name: "计时"
        }, {
          name: "套餐"
        }],
        tableNumberList: [{
            num: "59",
            name: "所有",
            bgcolor: "#fff",
            color: "#666"
          },
          {
            num: "59",
            name: "空闲",
            bgcolor: "#fff",
            color: "#666"
          },
          {
            num: "59",
            name: "预订",
            bgcolor: "#5E93FB",
            color: "#fff"
          },
          {
            num: "59",
            name: "开台",
            bgcolor: "#00CDC1",
            color: "#fff"
          },
          {
            num: "59",
            name: "点菜",
            bgcolor: "#AACC1E",
            color: "#fff"
          },
          {
            num: "59",
            name: "送单",
            bgcolor: "#3BCC1E",
            color: "#fff"
          },
          {
            num: "59",
            name: "上菜",
            bgcolor: "#FE9D24",
            color: "#fff"
          },
          {
            num: "59",
            name: "脏台",
            bgcolor: "#5C656E",
            color: "#fff"
          },
          {
            num: "59",
            name: "挂单",
            bgcolor: "#C293FE",
            color: "#fff"
          },
          {
            num: "59",
            name: "维修",
            bgcolor: "#FF3C62",
            color: "#fff"
          },
        ],
        tableList: [],
        copyList: [],
        orderList: [],
        orderStatus: 0,
        updatedorder: false,
        openTaiUser: JSON.parse(localStorage.getItem('openTaiUser')),
        foodBookId: '',
        //临时选中的对象
        selectobj: {
          food_name: "",
          quick_code: "",
          is_price_show1: true,
          unit_price1: "",
          unit_price2: "",
          number: '',
          is_can_update_price: false,
          is_can_update_name: false
        },
        selectObjNumber: '',
        labelIndex: -1,
        currentID: '',
        showRightIcon: true, // 是否显示右箭头
        maxClickNum: 0, // 最大点击次数
        lastLeft: 0, // 上次滑动距离
        clickNum: 0, // 点击次数
      };
    },
    created() {
      this.fetchFoodBook()

    },
    mounted() {

      this.$bus.$on("removeList", value => {
        let num = 0

        this.menuLeft.map(e => {
          if (value.foodTypeId == e.id) {

            num = e.menuNum - value.quantity

            this.$set(e, 'menuNum', num)

          }
        })
        this.tableList.map(vv => {
          if (vv.id == value.dishesId) {
            vv.number = 0
          }
        })



        this.$forceUpdate()
      });

      this.$bus.$on("reduceNumorderList", (value, n) => {
        let num = 0

        this.menuLeft.map(e => {
          if (value.foodTypeId == e.id) {

            num = e.menuNum

            this.$set(e, 'menuNum', num - 1)

          }
        })

        this.tableList.map(e => {
          if (value.dishesId == e.id) {

            num = e.number

            this.$set(e, 'number', num - 1)
          }
        })


        if (n) {

          this.tableList.map(vv => {
            if (vv.id == value.dishesId) {
              vv.number = 0
            }
          })


        }
        this.$forceUpdate()
      });

      this.$bus.$on('orderDishesList', (value) => {
        this.ordertable(value)
        this.ordermenuLeft(value)
      })
      this.$bus.$on('addNum', v => {

        let num = 0

        this.menuLeft.map(e => {
          if (v.foodTypeId == e.id) {
            console.log(e);
            num = e.menuNum

            this.$set(e, 'menuNum', num + 1)
          }
        })
        this.tableList.map(e => {
          if (v.dishesId == e.id) {
            console.log(e);
            num = e.number

            this.$set(e, 'number', num + 1)
          }
        })
      })
      this.$bus.$on('allCanel', value => {
        this.tableList.map(e => {



          e.number = 0

        })

        this.menuLeft.map(res => {
          res.menuNum = 0

        })
        this.$forceUpdate()
      })

      this.$bus.$on('status', value => {
        this.tableList.map(e => {
          value.map(v => {

            if (e.id == v.dishesId) {
              e.number = v.quantity
            }
          })
        })

        this.menuLeft.map(res => {
          res.menuNum = 0
          let num = 0
          value.map(v => {

            if (v.foodTypeId == res.id) {

              num = res.menuNum + v.quantity
              this.$set(res, 'menuNum', num)

              console.log(res.menuNum);
            }
          })
        })
        this.$forceUpdate()
      })

      this.$bus.$on('tableList', val => {
        this.orderList = val

      })

    },
    computed: {
      showLeftIcon() {
        return this.clickNum > 0
      }
    },
    updated() {
      this.$nextTick(() => {
        this.$bus.on("status", value => {
          this.orderStatus = value
        })
      })


    },
    watch: {

      orderStatus(newVal, oldVal) {
        console.log(newVal, oldVal);
        this.$bus.on("status", value => {
          newVal = value
        })
        if (newVal == 0) {
          this.menuLeft.forEach(v => {
            this.$set(v, 'menuNum', 0)
          })

          this.tableList.forEach(v => {
            this.$set(v, 'number', 0)
          })

        } else {
          let num = 0;

          this.menuLeft.forEach(vvv => {
            this.orderList.forEach(value => {
              if (value.food_type_name == vvv.description) {
                num += value.number
                // vvv.menuNum = num
                this.$set(vvv, 'menuNum', num)

              }

            })

          })

        }


      }


    },
    methods: {
      //loading
      loading(text) {
        const loading = this.$loading({
          lock: true,
          text: text,
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        setTimeout(() => {
          loading.close();
        }, 2000);
      },
      //初始化筛选菜品
      ordertable(value) {
        // console.log('orderDishesList',value);

        if (this.tableList.length) {
          console.log(value);
          this.tableList.map(e => {
            if (e.id == value.dishesId) {

              this.$set(e, 'number', value.quantity)

            }
          })
        } else {
          setTimeout(() => {
            this.ordertable(value)
          }, 500);
        }
      },
      //初始化筛选菜类
      ordermenuLeft(value) {
        if (this.menuLeft.length) {
          // console.log(value);
          let num = 0
          this.menuLeft.map(e => {
            if (e.id == value.foodTypeId) {
              num = e.menuNum + value.quantity

              this.$set(e, 'menuNum', num)


            }
          })
        } else {
          setTimeout(() => {
            this.ordermenuLeft(value)
          }, 500);
        }
      },
      //单击 点菜
      clickMenu(v, i) {
        clearTimeout(time); //首先清除计时器
        time = setTimeout(() => {
          console.log('点菜行', v);
          this.labelIndex = i
          this.orderStatus = 1
          if (!v.number) {
            this.$set(v, 'number', 1)
          } else {
            v.number++
          }

          //存 Bus.$emit
          this.$bus.emit("bload", v);



          this.menuLeft.forEach(vvv => {

            if (v.food_type_name == vvv.description) {
              if (vvv.menuNum) {
                vvv.menuNum++
              } else {
                vvv.menuNum = 1
              }
              // this.$set(vvv, 'menuNum', num)
              // console.log('menuLeft数组', this.menuLeft);
            }
          })

          this.tableList.forEach(vv => {
            if (vv.id == v.id) {
              vv.number = v.number
              // this.$set(vv, 'number', num++)
            }
          })
          this.$forceUpdate()
        }, 300);

      },
      //双击 点菜
      dbclickMenu(v, i) {
        clearTimeout(time); //清除
        this.selectobj = Object.assign({}, v)
        this.inputSearch = v.quick_code
        this.selectObjNumber = 1
        this.labelIndex = i
      },
      currentacClick(v, i) {

        if (this.currentac !== i) {
          this.currentac = i
          let arr = [this.current + 1, 0, 0, 0, v.id]
          if (this.menuDishStatus != -1) {
            arr[this.menuDishStatus + 1] = 1
          }
          this.updatedorder = true
          this.getMealList(arr)

        } else {
          this.currentac = -1
          this.updatedorder = false
          this.getMealList([this.current + 1])
        }
      },
      tjClick(v, i) {
        if (this.foodBookName) {
          if (this.currentac != -1) {
            let id = this.menuLeft[this.currentac].id
            let arr = [this.current + 1, 0, 0, 0, id]
            if (this.menuDishStatus !== i) {
              this.menuDishStatus = i

              arr[i + 1] = 1
              console.log(1, arr);
              this.getMealList(arr)

            } else {
              this.menuDishStatus = -1
              console.log(2, arr);

              this.getMealList(arr)

            }

          } else {
            let arr = [this.current + 1, 0, 0, 0]
            if (this.menuDishStatus !== i) {
              this.menuDishStatus = i

              arr[i + 1] = 1

              this.getMealList(arr)
              console.log(3, arr);


            } else {
              this.menuDishStatus = -1
              this.getMealList(arr)
              console.log(4, arr);

            }
          }
        }

      },

      getFoodTypeMap(foodBookId) {
        let url = this.api.getFoodTypeMap
        let methods = 'get'
        let data = {
          foodBookId: foodBookId,
        }
        this.$axios({
          url,
          methods,
          data
        }).then(res => {
          console.log(res);
          this.menuLeft = res.data.data
          this.menuLeft.forEach(v => {
            v.menuNum = 0;
            this.$set(v, 'menuNum', 0)
          })
        })
      },

      //获取中间菜的名字
      getMealList(arr) {
        // type  类型：1零点   2计时   3套餐
        // foodTypeId 菜类Id（暂时不需要）
        //foodBookId 菜本id（所有不传）
        //isRecommendFood  是否推荐菜  true是   false否
        //isWelcomeFood 是否欢迎菜  true是   false否
        // isHotFood 是否热卖菜  true是   false否
        let url = this.api.getMealList
        let methods = 'get'
        let data = {},
          foodTypeId = ''
        // console.log(arr);
        if (!arr) {
          data = {
            type: this.current + 1,
            foodBookId: this.foodBookId,
          }
        } else if (arr.length == 1) {
          data = {
            type: this.current + 1,
            foodBookId: this.foodBookId,
          }
        } else if (arr.length == 4) {
          data = {
            type: this.current + 1,
            foodBookId: this.foodBookId,
            isRecommendFood: arr[1],
            isWelcomeFood: arr[2],
            isHotFood: arr[3]
          }
          if (!arr[1]) {
            delete data.isRecommendFood;
          }
          if (!arr[2]) {
            delete data.isWelcomeFood;
          }
          if (!arr[3]) {
            delete data.isHotFood;
          }
        } else if (arr.length == 5) {
          data = {
            type: this.current + 1,
            foodBookId: this.foodBookId,
            isRecommendFood: arr[1],
            isWelcomeFood: arr[2],
            isHotFood: arr[3],
            foodTypeId: arr[4]
          }
          foodTypeId = arr[4]
          if (!arr[1]) {
            delete data.isRecommendFood;
          }
          if (!arr[2]) {
            delete data.isWelcomeFood;
          }
          if (!arr[3]) {
            delete data.isHotFood;
          }
        }
        // data = JSON.stringify(data)
        const loading = this.$loading({
          lock: true,
          text: '加载中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        this.$axios({
          url,
          methods,
          data
        }).then(res => {
          // console.log(res);
          // console.log;


          console.log('orderList', this.orderList);
          if (this.orderList.length) {
            console.log('第二次渲染');

            this.tableList = this.updatetablelist(this.orderList, res.data.data, foodTypeId)

            loading.close();
          } else {

            this.tableList = res.data.data
            loading.close();
          }

          this.copyList = res.data.data


        }).catch(e => {
          loading.close();
        })

      },
      //回显左侧菜品数量
      updatetablelist(arr, arr1, foodTypeId) {

        console.log(arr, foodTypeId);
        if (foodTypeId) {
          arr.map(e => {

            if (e.foodTypeId == foodTypeId) {
              arr1.map(n => {
                if (n.id == e.dishesId) {
                  console.log('updatetablelist', n, e);
                  n.number = e.quantity
                  this.$set(arr1, 'number', e.number)
                }
              })
            }
          })

        } else {
          arr.map(e => {
            arr1.map(n => {
              if (n.id == e.dishesId) {
                console.log('updatetablelist', n, e);
                n.number = e.quantity
                this.$set(arr1, 'number', e.number)
              }
            })
          })


        }

        return arr1
      },

      //切换菜谱
      menuNameCheck(v, i) {
        let url = this.api.getMealList
        let methods = 'get'
        // type  类型：1零点   2计时   3套餐
        // foodTypeId 菜类Id（暂时不需要）
        //foodBookId 菜本id（所有不传）
        //isRecommendFood  是否推荐菜  true是   false否
        //isWelcomeFood 是否欢迎菜  true是   false否
        // isHotFood 是否热卖菜  true是   false否
        let data = {
          type: this.current + 1,
          foodBookId: v.id,
        }
        this.getFoodTypeMap(v.id)
        // data = JSON.stringify(data)
        this.$axios({
          url,
          methods,
          data
        }).then(res => {

          this.foodBookName = v.description
          this.foodBookId = v.id
          this.tableList = res.data.data
          this.copyList = res.data.data
          this.menuCheckCurrentItem = i;
          this.menuCheckDialog = false;
          this.inputSearch = ''

        })

      },
      //获取菜本列表
      fetchFoodBook() {

        // let id = JSON.parse(localStorage.getItem('openTaiUstatus '))
        // console.log('openTaiUstatus', id);
        let ids = this.$route.query.outletsId

        let url = this.api.getFoodBookList + '?outletsId=' + ids
        let methods = 'get'
        // return
        this.$axios({
          url,
          methods
        }).then(res => {

          this.menuCheckList = res.data.data
          this.menuCheckList.sort((a, b) => {
            return a.code - b.code
          })
          //升序
          this.foodBookName = res.data.data[0].description
          if (res.data.data.length) {
            this.foodBookId = res.data.data[0].id
            this.getFoodTypeMap(res.data.data[0].id)
            this.getMealList()
            this.$nextTick(() => {
              this.getDomStyle()

            })
          }

        })

      },
      // 打开菜本弹窗
      menuCheck() {
        this.fetchFoodBook()
        this.menuCheckDialog = !this.menuCheckDialog;

      },
      //九宫格分类
      styleCheck(i) {
        console.log(i);
        this.styleCurrentList = i
        this.styleCurrent = i


      },
      // 零点 计时 套餐按钮 获取菜品
      currentCheck(i) {
        this.current = i;
        let url = this.api.getMealList
        let methods = 'get'
        let data = {
          type: this.current + 1,
          foodBookId: this.foodBookId,
        }

        // data = JSON.stringify(data)

        this.$axios({
          url,
          methods,
          data
        }).then(res => {
          // console.log('orderList', this.orderList);

          if (this.orderList.length) {

            this.tableList = this.updatetablelist(this.orderList, res.data.data)


          } else {

            this.tableList = res.data.data

          }

          this.copyList = res.data.data


        })

      },
      //搜索框
      changeSearch(val) {
        let arr = [],
          arr1 = [],
          text = ''
        this.selectobj = {}
        this.selectObjNumber = ''
        this.labelIndex = 0
        var pattern2 = new RegExp("[A-Za-z]+");

        // var str2 = "abcdefsgaaweg"

        if (pattern2.test(val)) {

          console.log('123', val);
          text = val.toUpperCase()
          this.$nextTick(() => {
            this.inputSearch = val.toUpperCase()
          })

        } else {
          text = val
        }

        if (text) {

          arr1 = this.tableList.filter(item => item.quick_code == text)
          if (arr1.length) {
            this.selectobj = JSON.parse(JSON.stringify(arr1[0]))

            this.selectObjNumber = 1
          }
          this.copyList.forEach(e => {
            if (e.code.indexOf(text) != -1 || e.food_name.indexOf(text) != -1 || e.quick_code.indexOf(text) != -1) {
              arr.push(e)
            }

          })
          this.tableList = arr
        } else {
          // this.fetchFoodBook()
          this.getFoodTypeMap(this.foodBookId)
        }
      },

      focusNext(nextRef) {
        this.$refs[nextRef].focus()
      },
      focusSubmit(nextRef) {

        if (this.selectobj.id && this.selectObjNumber) {

          this.selectobj.quantity = this.selectObjNumber
          this.$bus.emit("bload", this.selectobj);


          this.menuLeft.forEach(vvv => {

            if (this.selectobj.food_type_name == vvv.description) {
              if (vvv.menuNum) {
                vvv.menuNum += this.selectObjNumber * 1
              } else {
                vvv.menuNum = this.selectObjNumber * 1
              }

            }
          })

          this.tableList.forEach(vv => {
            if (vv.id == this.selectobj.id) {
              if (vv.number) {
                vv.number += this.selectObjNumber * 1
              } else {
                vv.number = this.selectObjNumber * 1
              }
            }
          })
          this.selectobj = JSON.parse(JSON.stringify({
            food_name: "",
            quick_code: "",
            is_price_show1: true,
            unit_price1: "",
            unit_price2: "",
            number: '',
            is_can_update_price: false,
            is_can_update_name: false
          }))
          this.selectObjNumber = ''
          this.inputSearch = ''
          this.$refs[nextRef].focus()
          this.tableList = this.copyList
        }

      },
      //餐桌左右按钮
      getDomStyle() {
        let width = document.querySelectorAll('.classifys-item')[this.clickNum].offsetWidth
        // 获取最后一个元素距离左侧的距离
        let lastItemOffsetLeft = document.getElementsByClassName('classifys-item')[this.menuCheckList.length - 1]
          .offsetLeft
        // 获取可视区域宽度
        const lookWidth = document.getElementById('classifyScroll').clientWidth
        // 如果最后一个元素距离左侧的距离大于可视区域的宽度，表示最后一个元素没有出现，执行滚动效果
        //  this.showRightIcon = lastItemOffsetLeft > lookWidth + width
      },
      rightClick() {
        // 如果点击次数小于数组长度-1时，执行左滑动效果。
        if (this.clickNum < this.cantList.length - 1) {
          // 获取当前元素宽度
          let width = document.querySelectorAll('.classifys-item')[this.clickNum].offsetWidth
          // 获取最后一个元素距离左侧的距离
          let lastItemOffsetLeft = document.getElementsByClassName('classifys-item')[this.menuCheckList.length - 1]
            .offsetLeft
          // 获取可视区域宽度
          const lookWidth = document.getElementById('classifyScroll').clientWidth
          // 如果最后一个元素距离左侧的距离大于可视区域的宽度，表示最后一个元素没有出现，执行滚动效果
          console.log('获取当前元素的宽度', width, lastItemOffsetLeft, lookWidth);

          if (lastItemOffsetLeft > lookWidth) {

            // // 第一次点击的时候，加上左右箭头的距离
            if (this.clickNum == 0) {
              // 公示：滚动距离（元素的magin-left值） = 负的它自己的长度 + 上一次滑动的距离
              document.getElementsByClassName('classifys')[0].style.marginLeft = `${-width + this.lastLeft -20}px`
            } else {
              document.getElementsByClassName('classifys')[0].style.marginLeft = `${-width + this.lastLeft -20}px`
            }
            this.lastLeft = -width + this.lastLeft
            console.log(this.lastLeft);
            // 点击次数+1
            this.clickNum += 1
            // 记录到最后一个元素出现在可视区域时，点击次数的最大值。用于后面点击左侧箭头时判断右侧箭头的显示
            this.maxClickNum = this.clickNum
          }
          /* 
            如果最后一个元素距离左侧的距离大于可视距离+自身的宽度，说明没有到最后一个, 显示右侧箭头，否则隐藏右侧箭头
            注意：这里要加上其自身的宽度，否则要多点击一下才会隐藏。因为点击的时候实际上最后一个元素还没有滚动，
            它距离左侧的距离是大于可视区域的（也就是说获取的是上一次点击之后，距离左侧的距离）
            所以这里要加上其自身的宽度
            看不懂的话不用管，反正加上就对了
          */
          this.showRightIcon = lastItemOffsetLeft > lookWidth
        }
      },
      // 点击左箭头（右侧滚动）
      leftClick() {
        // console.log(this.lastLeft, 'lastLeft')
        // console.log(document.querySelectorAll('.classifys-item')[this.clickNum - 1].offsetWidth, '上一个的宽度')
        // 当点击次数大于0时才触发，这样当点击次数clickNum等于1的到时候，clickNum--等于0.根据计算属性的判断会隐藏掉左箭头
        if (this.clickNum > 0) {
          // 获取当前元素宽度
          let width = document.querySelectorAll('.classifys-item')[this.clickNum - 1].offsetWidth
          // 公示：滚动距离（元素的magin-left值） = 它自己的长度 + 上一次滑动的距离
          document.getElementsByClassName('classifys')[0].style.marginLeft = `${this.lastLeft + width}px`
          this.lastLeft = width + this.lastLeft
          // 点击次数-1
          this.clickNum--
          // 如果点击次数小于最大点击次数，说明最后一个元素已经不在可是区域内了，显示右箭头
          if (this.clickNum < this.maxClickNum) {
            this.showRightIcon = true
          }
        }
      }


    },
  };
</script>

<style lang="scss" scoped>
  @function px($px) {
    @return $px * 2px;
  }

  .all {
    width: 100%;
    height: 100%;
    overflow-y: auto;
  }

  .leftMenu {
    height: calc(100% - 50px);
    display: flex;

    .menu {
      width: 260px;
      height: 100%;

      border-right: 1px solid #eaeaea;
      overflow: auto;


      .checkMenu {
        height: 50px;
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 15px 30px;
        border-bottom: 1px solid #eaeaea;

        span:nth-child(1) {
          font-size: 18px;
          color: #0099ff;
        }

        span:nth-child(2) {
          font-size: 18px;
          color: #666666;
        }
      }

      .menuDish {
        height: 198px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        font-size: 18px;
        border-bottom: 1px solid #eaeaea;
        color: #666;

        .menuDishItem {
          cursor: pointer;
          width: 100%;
        }

        .menuDishItemCurrent {
          background: #0099ff;
          color: #fff;
        }

        div {
          height: 33%;
          display: flex;
          align-items: center;
        }
      }

      .menuClass {

        .menuItem {
          width: 100%;
          height: 66px;
          display: flex;
          align-items: center;
          padding-left: 40px;
          padding-right: 20px;
          font-size: 18px;
          color: #666;
          cursor: pointer;
          display: flex;
          justify-content: space-between;

          .menuItemNum {
            width: 22px;
            height: 22px;
            background: #f5581a;
            text-align: center;
            line-height: 22px;
            border-radius: 11px;
            color: #fff;
            font-size: 14px;
          }
        }

        .menuItemActive {
          background: #0099ff;
          color: #fff;
        }
      }
    }

    .dishes {
      width: calc(100% - 200px);
      // width: 100%;
      height: 100%;
      // height: calc(100% - 50px);
      overflow: auto;

      .leftdishes {
        overflow: auto;
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        margin-right: 10px;
        border-radius: 20px;

        .CTClassification {
          display: flex;
          justify-content: space-around;
          align-items: center;
          // margin: 13px 0;
          // padding-bottom: 12px;
          border-bottom: 1px solid #eee;
          flex: 0 0 50px;

          .ctItem {
            width: 100px;
            height: 40px;
            text-align: center;
            line-height: 40px;
            border-radius: 20px;
            color: #666666;
            border: 1px solid #eee;
            cursor: pointer;
          }

          .currentCT {
            background: #0099ff;
            color: #fff;
          }
        }

        .tableClassification {
          flex: 1;
          padding: 0 10px;
          display: flex;
          flex-wrap: wrap;
          height: 80%;
          align-content: flex-start;
          overflow-y: auto;

          .tableItem {
            cursor: pointer;
            width: 32%;
            height: 124px;
            border: 1px solid #eaeaea;
            border-radius: 6px;
            display: flex;
            flex-direction: column;
            color: #666;
            padding: 25px 10px 10px 4px;
            position: relative;
            margin: 4px;

            .tableName {
              line-height: 40px;
              font-weight: 500;
              font-size: 28px;
              display: flex;
              justify-content: start;
              margin-bottom: 25px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }

            .tableNum {
              width: 100%;
              align-items: flex-end;
              display: flex;
              justify-content: space-between;
            }

            .topNumber {
              position: absolute;
              right: 5px;
              top: 5px;
              width: 20px;
              height: 20px;
              border-radius: 10px;
              background: #f5581a;
              color: #fff;
              text-align: center;
              line-height: 20px;
              font-size: 12px;
            }

            .topImg {
              position: absolute;
              right: 30px;
              top: 5px;
            }

            .topCode {
              position: absolute;
              left: 10px;
              top: 5px;
            }

          }
        }

        .tableClassificationTwo {
          padding: 0 10px;
          flex: 1;
          // overflow-y: scroll;
          // overflow-y: hidden;

          .labelIndex {
            background: #228be6;
            color: #fff;

          }

          .tableNum {
            display: grid;
            grid-template-columns: 1fr 1fr 1fr 1fr;
            align-items: center;
            justify-content: space-between;
            border-bottom: 1px solid #eee;
            padding-bottom: 10px;
            padding-top: 5px;

            .unitPrice {
              color: #fe8d30;
              font-size: 20px;
              text-align: right;
            }
          }

        }

        .tableClassificationThree {
          // padding: 0 10px;
          flex: 1;
          display: flex;
          flex-wrap: wrap;
          height: 80%;
          align-content: flex-start;
          overflow-y: auto;

          .tableItem {
            cursor: pointer;
            width: 48.5%;
            height: 124px;
            border: 1px solid #eaeaea;
            border-radius: 6px;
            display: flex;
            color: #666;
            margin: 5px;
            position: relative;

            .tableNum {
              width: 100%;
              align-items: center;
              display: flex;
              justify-content: space-between;
            }

            .rightName {
              padding: 20px 10px 12px 10px;
              width: calc(100% - 160px);

              div {
                width: 100%;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }

            .topNumber {
              position: absolute;
              right: 5px;
              top: 5px;
              width: 20px;
              height: 20px;
              border-radius: 10px;
              background: #f5581a;
              color: #fff;
              text-align: center;
              line-height: 20px;
              font-size: 12px;
            }

            .topImg {
              position: absolute;
              left: 150px;
              top: 55px;
            }

            .topCode {
              position: absolute;
              left: 155px;
              top: 5px;
            }
          }
        }

        .tableClassificationFour {
          padding: 0 10px;
          flex: 1;
          display: flex;
          flex-wrap: wrap;
          height: 80%;
          align-content: flex-start;
          overflow-y: auto;

          .tableItem {
            cursor: pointer;
            width: 31.8%;
            height: 258px;
            border: 1px solid #eaeaea;
            border-radius: 6px;
            display: flex;
            color: #666;
            margin: 4px;
            position: relative;

            .tableName {
              width: 100%;
              height: 100%;
            }

            .tableNum {
              width: 100%;
              align-items: flex-end;
              display: flex;
              justify-content: space-between;
            }

            .rightName {
              display: flex;
              flex-direction: column;
              align-items: center;
              width: 100%;
              height: 88px;
              background: rgba($color: #000000, $alpha: 0.7);
              padding: 15px 10px 12px 10px;
              position: absolute;
              bottom: 0;
              left: 0;

              // width: calc(100% - 160px);
              div {
                width: 100%;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }

            .topNumber {
              position: absolute;
              right: 5px;
              top: 5px;
              width: 20px;
              height: 20px;
              border-radius: 10px;
              background: #f5581a;
              color: #fff;
              text-align: center;
              line-height: 20px;
              font-size: 12px;
            }

            .topImg {
              position: absolute;
              right: 10px;
              bottom: 90px;
            }

            .topCode {
              position: absolute;
              left: 10px;
              top: 5px;
            }
          }
        }

        .tableBottom {
          flex: 0 0 50px;
          display: flex;
          padding: 15px 5px 0 5px;
          align-items: center;
          justify-content: space-around;
          border-top: 1px solid #eee;
          position: sticky;
          bottom: 0px;
          background: #fff;
        }
      }
    }
  }

  .ALLtitle {
    position: relative;
    border-bottom: 1px solid #eaeaea;
    height: 50px;
  }

  #classifyScroll {
    padding: 0 px(6);
    width: 95%;
    overflow: hidden;
    transition: all 0.3s;

    // 鼠标点击后，页面可视宽度变低
    &.active {
      transition: all 0.3s;
      width: 84%;
      margin: 0 auto;
    }

    .classifys {
      transition: all 0.3s;
      display: flex;
      align-items: center;
      height: 50px;

      .rightIcon {
        position: absolute;
        right: px(2);
        bottom: 47%;
        transform: translate(0, 50%);
        z-index: 9;
      }

      .leftIcon {
        position: absolute;
        left: px(5);
        bottom: 47%;
        transform: translate(0, 50%);
        z-index: 9;
      }

      &-item {
        font-size: px(5);
        font-weight: 400;
        color: #666;
        width: 130px;
        line-height: px(16);
        margin-right: px(10);
        // padding: 0 px(4);
        white-space: nowrap;
        border-radius: 20px;
        cursor: pointer;
      }

      .ctItem {
        width: 130px;
        height: 40px;
        text-align: center;
        line-height: 40px;
        border-radius: 20px;
        color: #000;
        background: #eee;
        cursor: pointer;
      }

      .currentCT {
        background: #0099ff;
        color: #fff;
      }
    }
  }
</style>
<style lang="scss" scoped>
  // /deep/.el-dialog {
  //   display: flex;
  //   flex-direction: column;
  //   align-items: center;
  //   border-radius: 20px;
  // }
  /deep/ .el-dialog {
    margin-top: 9vh !important;
    margin-bottom: 8vh !important;
    overflow: auto;
    border-radius: 20px;
  }

  /deep/.el-dialog__header {
    margin-top: 20px;
    background: #fff;
  }

  /deep/.el-dialog__title {
    color: #0099ff;
    font-size: 28px;
  }

  /deep/.el-dialog__body {
    // height: 322px;
    overflow: auto;
  }
</style>